module.exports = __webpack_public_path__ + "media/images/logout-c6727490ee83ef957b4ed1ecb21cd0d7.svg";